import _indexOf from 'lodash/indexOf';

export const hasBoundingBoxAdjustedTag = (tags: string[]): boolean => {
  // flag set on the backend for a page which has had its elements line heights adjusted
  // for a rendering improvement, this is required for backwards compatibility
  return _indexOf(tags, 'bounding_boxes_adjusted') !== -1;
};
